import React from 'react';
import styled from 'styled-components';
import { MinusCircleOutlined } from '@ant-design/icons';

/**
 * The M365 state for a customer whose Microsoft 365 tenant CSG does not manage (no CIPP id,
 * spec 2026-10-19). Neutral, not a warning: nothing is wrong, there is just no tenant to show.
 */

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
  padding: ${({ theme }) => theme.spacing.lg} ${({ theme }) => theme.spacing.md};
  text-align: center;
`;

const Icon = styled(MinusCircleOutlined)`
  font-size: 28px;
  color: ${({ theme }) => theme.colors.textMuted};
`;

const Title = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize.base};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text};
`;

const Body = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize.sm};
  color: ${({ theme }) => theme.colors.textMuted};
`;

const M365NotManaged = () => (
  <Wrapper>
    <Icon />
    <Title>Not managed</Title>
    <Body>CSG doesn&apos;t manage this customer&apos;s Microsoft 365 tenant.</Body>
  </Wrapper>
);

export default M365NotManaged;
